import React from "react";
import { t } from "@auto/services";

import ReportingWidget from "@src/reporting/components/ReportingWidget";
import RegisteredVoterAgeDistributionWidget from "@src/reporting/widgets/RegisteredVoterAgeDistributionWidget";
import RegisteredVoterSexDistributionWidget from "@src/reporting/widgets/RegisteredVoterSexDistributionWidget";

import styles from "@src/reporting/Reporting.module.styl";

const DemographicsWidget = ({ filter, refreshToken = 0, compact = false }) => (
  <ReportingWidget
    title={t("reporting.voterDemographics")}
    subtitle={t("reporting.voterDemographicsSubtitle")}
  >
    <div className={compact ? styles.chartGridOne : styles.chartGridTwo}>
      <RegisteredVoterSexDistributionWidget
        filter={filter}
        refreshToken={refreshToken}
      />
      <RegisteredVoterAgeDistributionWidget
        filter={filter}
        refreshToken={refreshToken}
      />
    </div>
  </ReportingWidget>
);

export default DemographicsWidget;
